// Shared constants for the landing page
export const TELEGRAM_URL = "https://t.me/+Dd-MSHp7gI40M2E0";
